<script setup lang="ts">
import { MessageList } from '@/objects';
import { toStringArray } from '@/utils';
import { computed, nextTick, useTemplateRef, watch } from 'vue';

const { messages, firstLeft = false } = defineProps<{
    messages: MessageList,
    firstLeft?: boolean
}>()

const wrapper = useTemplateRef('wrapper')

const msgCount = computed(() => {
    return messages.flat().length
})

watch(msgCount, () => {
    nextTick(() => {
        const target = wrapper.value.lastElementChild
        if (!target) {
            return
        }

        target.scrollIntoView({
            behavior: 'smooth'
        })
    })
})

</script>

<template>
    <div ref="wrapper" class="col gap-3">
        <template v-for="(block, idx) in messages" :key="idx">
            <div v-for="(msg, msgIdx) in toStringArray(block)" :key="msgIdx"
            class="max-w-[80%] min-h-11 bg-gray-300 px-4 py-2 wrap-break-word rounded-t-md"
            :class="(idx%2 !== 0) != firstLeft ? 'other' : 'mine'"
            >
                {{ msg }}
            </div>
        </template>
    </div>
</template>

<style scoped>
@reference 'tailwindcss';
@reference '#app.css';

.other {
    @apply mr-auto text-left bg-transparent border border-pink-700 rounded-br-md;
}

.mine {
    @apply ml-auto text-right bg-pink-650 rounded-bl-md;
}
</style>